import React, { createContext, useMemo, useReducer } from 'react';
import messageActions from '@/actions/shared/messageActions';
import messageReducer from '@/reducers/shared/messageReducer';

export const MessageContext = createContext();

const MessageContextProvider = (props) => {
  const [messageState, dispatch] = useReducer(messageReducer, {
    messageListProgress: false,
    messageListLoaded: false,
    messageListError: null,
    messageList: [],
    messageListTotal: 0,
    messageListOffset: 0,
    messageListLimit: 60,
    messageListIsOld: true,
    messagePostProgress: false,
    messagePostLoaded: false,
    messagePostError: null,
  });
  const actions = useMemo(() => messageActions(dispatch), [dispatch]);

  return (
    <MessageContext.Provider value={{ messageState, dispatch, actions }}>
      {props.children}
    </MessageContext.Provider>
  );
};

export default MessageContextProvider;
